import Vue from "vue";

var loverI18n = {
  get: function (lan) {
    return Vue.locale.get();
  },
  set: function (lan) {
    const nowLocale = Vue.locale.get();
    Vue.i18n.set(lan);
    Vue.locale.set(lan);
  }
};

export default loverI18n;



// WEBPACK FOOTER //
// ./src/utils/i18nChange.js